<div class="gl-dashboard__title">
  <span>{{ 'dashboard.widgets.studentsCourse' | translate }}</span>
  <button
    type="button"
    lmsTooltip
    [tooltipConfig]="{
      positionV: 'top',
      positionH: 'center',
      text: ['dashboard.widgets.studentsTooltip' | translate]
    }"
    class="un-btn"
  >
    <span class="glicon-info"></span>
  </button>
</div>
<div *ngIf="!studentCourses || !studentCourses.length" class="gl-dashboard__item--void">
  <span>{{ 'dashboard.widgets.studentsVoid' | translate }}</span>
</div>
<div *ngFor="let studentCourse of studentCourses; index as i; trackBy: trackByStudentCourse">
  <div class="gl-dashboard__subtitle">
    {{ i + 1 }}. {{ studentCourse['name'] || 'dashboard.widgets.noGameName' | translate }}
  </div>
  <lms-chart-speedometer
    [showHorizontal]="true"
    [primaryValue]="studentCourse['completed'] | lmsCalcPercentage : studentCourse['total']"
  ></lms-chart-speedometer>
  <div
    class="gl-dashboard__label"
    [innerHTML]="
      'dashboard.widgets.endStudents'
        | translate
          : {
              completedStudents: studentCourse['completed'],
              totalStudents: studentCourse['total'],
              totalPercentage:
                studentCourse['completed'] | lmsCalcPercentage : studentCourse['total'] | number : '1.1-2'
            }
    "
  >
    >
  </div>
</div>
